import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { usePDF } from "react-to-pdf";

import styles from "./App.module.css";

import { getBoletim } from "../../api/BoletimService";

import Auth from "../../components/Auth/Auth";
import Boletim from "../../components/Boletim/Boletim";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import PeriodSelector from "../../components/PeriodSelector/PeriodSelector";

function App() {
    const location = useLocation();
    const { toPDF, targetRef } = usePDF({
        filename: "boletim-de-desempenho-link.pdf",
        page: {
            margin: 5,
            format: [210, 2000],
            orientation: "portrait",
        }
    });
    const [boletim, setBoletim] = useState();
    const [ra, setRa] = useState();
    const [period, setPeriod] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [authCode, setAuthCode] = useState();
    const [isAuth, setIsAuth] = useState(false);
    const [authError, setAuthError] = useState(false);

    const handleAuthenticate = async () => {
        setIsLoading(true);

        var onAuthError = false;

        const _boletim = await getBoletim(ra, authCode, period).catch((error) => {
            onAuthError = true;
            setAuthError(true);
        });

        if (!onAuthError) {
            setBoletim(_boletim);
            setIsAuth(true);
        }

        setIsLoading(false);
    };

    useEffect(() => {
        const currentPath = location.pathname.split("/");

        const _period = currentPath[1];
        const _ra = currentPath[currentPath.length - 1];

        if (_ra !== ra) {
            // Exige autenticação ao mudar RA
            setIsAuth(false);
        }

        setRa(_ra);
        setPeriod(_period);

        if (isAuth) {
            // Already Authenticated
            handleAuthenticate();
        }
    }, [location.pathname]);

    return (
        <div className={styles.app}>
            {!isAuth ? (
                <Auth
                    setAuthCode={setAuthCode}
                    authenticate={handleAuthenticate}
                    isLoading={isLoading}
                    error={authError}
                    errorText={"Os 6 digitos não correspondem ao CPF do aluno ou o RA está incorreto."}
                />
            ) : (
                <>
                    <Header toPDF={toPDF} isBoletimLoading={isLoading} />
                    {ra && period && (
                        <PeriodSelector
                            ra={ra}
                            period={period.replace("-", ".")}
                            setPeriod={setPeriod}
                            setIsLoading={setIsLoading}
                        />
                    )}
                    <Boletim
                        pdfTargetRef={targetRef}
                        boletim={boletim}
                        period={period.replace("-", ".")}
                        isLoading={isLoading}
                    />
                    <Footer />
                </>
            )}
        </div>
    );
}

export default App;
